import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faXmark } from '@fortawesome/free-solid-svg-icons'
import InstagramIcon from '../../assets/icons/instagram.svg?react'
import { useAppType } from '../../context/AppContext'
import { BRANDS } from '../../utils/brand'
import { bombExplosion } from '../../utils/bomb'
import './Credit.scss'

const c = 'credit'
const DEV_INSTAGRAM = 'https://www.instagram.com/ahmedvengriniuc/'

const Credit = () => {
  const brand = BRANDS[useAppType()]
  const [showInsta, setShowInsta] = useState(false)

  useEffect(() => {
    if (!showInsta) return
    const id = window.setTimeout(() => setShowInsta(false), 12000)
    return () => window.clearTimeout(id)
  }, [showInsta])

  return (
    <div className={c}>
      © {new Date().getFullYear()} {brand.first} {brand.second} · made with{' '}
      <FontAwesomeIcon icon={faHeart} className={`${c}__heart`} /> ·{' '}
      <button
        type='button'
        className={`${c}__dev`}
        onClick={(e) =>
          bombExplosion(e.clientX, e.clientY, () => setShowInsta(true))
        }
      >
        Developed by <b>Ahmed</b>
      </button>
      {showInsta &&
        createPortal(
          <div
            className={`${c}__insta-wrap`}
            onClick={() => setShowInsta(false)}
          >
            <a
              className={`${c}__insta-card`}
              href={DEV_INSTAGRAM}
              target='_blank'
              rel='noreferrer'
              onClick={(e) => e.stopPropagation()}
            >
              <span className={`${c}__insta-icon`}>
                <InstagramIcon />
              </span>
              <span className={`${c}__insta-text`}>
                <small>Follow the developer</small>
                <b>@ahmedvengriniuc</b>
              </span>
            </a>
            <button
              type='button'
              className={`${c}__insta-close`}
              aria-label='Close'
              onClick={() => setShowInsta(false)}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>,
          document.body,
        )}
    </div>
  )
}

export default Credit
